import { render } from "./ArgonInput.vue?vue&type=template&id=d4ee0d96"
import script from "./ArgonInput.vue?vue&type=script&lang=js"
export * from "./ArgonInput.vue?vue&type=script&lang=js"

import exportComponent from "D:\\root\\baam\\viribuz\\viribuz-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__